// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Chiudi',
  error: () => 'Errore',
  warn: () => 'Avvertenza',
  info: () => 'Informazioni',
  confirmation: () => 'Conferma',
  progressIndeterminate: () => 'In corso',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Tra ' + p['FROM_SECTION'] + ' e ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nessuna sezione corrispondente trovata.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Premere Invio per selezionare un valore.',
  indexer_touchInstructionText: () =>
    'Toccare 2 volte e tenere premuto per immettere la modalità movimento,quindi trascinare su o giù per regolare il valore.',
  inputPassword_show: () => 'Mostra password',
  inputPassword_hide: () => 'Nascondi password',
  inputPassword_hidden: () => 'Password nascosta',
  formControl_clear: () => 'Cancella',
  formControl_loading: () => 'Caricamento',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Lunghezza massima ' + p['MAX_LENGTH'] + ' superata.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caratteri rimanenti.',
  formControl_requiredMessageDetail: () => 'Immettere un valore.',
  select_requiredMessageDetail: () => 'Selezionare un valore.',
  select_noMatchesFound: () => 'Nessuna corrispondenza trovata.',
  select_oneMatchFound: () => 'Una corrispondenza trovata',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Trovate ' + p['TOTAL_SIZE'] + ' corrispondenze',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Trovate ' + p['TOTAL_SIZE'] + ' o più corrispondenze',
  selectMultiple_selectedValues: () => 'Valori selezionati',
  selectMultiple_showSelectedValues: () => 'Mostra solo i valori selezionati.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valori selezionati.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Premere Backspace o Canc per rimuovere il valore selezionato.',
  selectMultiple_apply: () => 'Applica',
  selectMultiple_back: () => 'Indietro',
  selector_selected: () => 'Casella di controllo selezionata',
  selector_unselected: () => 'Casella di controllo non selezionata',
  userAssistance_learnMore: () => 'Ulteriori informazioni',
  userAssistance_required: () => 'Obbligatorio',
  filePicker_singleFileUploadError: () => 'Caricare un solo file alla volta',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Impossibile caricare i file del tipo ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Impossibile caricare file di questo tipo: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'sconosciuto',
  filePicker_dropzonePrimaryText: () => 'Trascina selezione',
  filePicker_dropzoneSecondaryText: () => 'Selezionare un file o rilasciarne uno qui',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selezionare o rilasciare i file qui',
  filePicker_addFiles: () => 'Aggiungi file',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Aumenta',
  inputNumber_decrease: () => 'Riduci',
  inputNumber_converterParseError: () => 'Immettere un numero.',
  noData_message: () => 'Nessun elemento da visualizzare',
  message_navigationFromMessagesRegion: () =>
    "Accesso all'area messaggi. Premere F6 per ritornare all'elemento evidenziato in precedenza.",
  message_navigationToMessagesRegion: () =>
    "L'area messaggi contiene nuovi messaggi. Premere F6 per andare all'area messaggi più recenti.",
  messageToast_allMessagesClosed: () => 'Tutti i messaggi popup sono chiusi.',
  expandableList_groupCollapse: () => 'Compresso',
  expandableList_groupExpand: () => 'Espanso',
  expandableList_expandCollapseInstructionText: () =>
    'Utilizzare i tasti freccia per espandere e comprimere',
  list_suggestion: () => 'Suggerimento',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Passo ' + p['currentStep'] + ' di ' + p['numberOfSteps'],
  train_current: () => 'Corrente',
  train_visited: () => 'Visitato',
  train_not_visited: () => 'Non visitato',
  train_message_type: () => 'Tipo di messaggio',
  viz_drillable: () => 'Con drilling',
  dataVisualization_stateSelected: () => 'Selezionato',
  dataVisualization_stateUnselected: () => 'Non selezionato',
  dataVisualization_noData: () => 'Nessun dato da visualizzare'
};
export default bundle;
